import { NgbNavModule, NgbScrollSpyModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CoreModule } from '@abp/ng.core';
import { AgGridAngular } from '@ag-grid-community/angular';
import { LowerCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { DwAgGridModule } from '@digiwall/ag-grid';
import {
  DwNavLinkDirective,
  PreventEnterDefaultDirective,
  AddressDetailComponent,
} from '@digiwall/core';
import { FileUrlPipe } from '@digiwall/file-management';
import {
  SharedModule,
  AnnexesListModule,
  InformationsAuditedEntityComponent,
} from '@digiwall/goliath-core';
import {
  TableModule,
  SidePanelModule,
  DialogBoxComponent,
  KpiGridComponent,
  KpiComponent,
  AmountCardComponent,
} from '@digiwall/ui-kit';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReportViewerComponent } from '@odyssey/reporting';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import {
  LinesEditorComponent,
  InvoiceTagComponent,
  DocHierarchyComponent,
  DocHierarchyItemComponent,
} from '../components';
import { DocClassificationsComponent } from './base-docs/detail/doc-classifications/doc-classifications.component';
import { DocConditionsComponent } from './base-docs/detail/doc-conditions/doc-conditions.component';
import { DocCustomerAddressesComponent } from './base-docs/detail/doc-customer-addresses/doc-customer-addresses.component';
import { DocCustomerDeliveryAddressComponent } from './base-docs/detail/doc-customer-addresses/doc-customer-delivery-address.component';
import { DocCustomerOthersComponent } from './base-docs/detail/doc-customer-others/doc-customer-others.component';
import { DocSupplierAddressesComponent } from './base-docs/detail/doc-supplier-addresses/doc-supplier-addresses.component';
import { DocSupplierDeliveryAddressComponent } from './base-docs/detail/doc-supplier-addresses/doc-supplier-delivery-address.component';
import { DocSupplierOthersComponent } from './base-docs/detail/doc-supplier-others/doc-supplier-others.component';
import { DocTemplateSelectionComponent } from './base-docs/detail/doc-template-selection/doc-template-selection/doc-template-selection.component';
import { DocSidePanelExplanationsComponent } from './base-docs/detail/doc-ui-components/side-panel-explanations/side-panel-explanations.component';
import { DocSidePanelTagsComponent } from './base-docs/detail/doc-ui-components/side-panel-tags/side-panel-tags.component';
import { CustomerCreditNoteDetailComponent } from './customer-credit-notes/customer-credit-note-details/customer-credit-note-detail.component';
import { CustomerCreditNoteLinesEditorComponent } from './customer-credit-notes/customer-credit-note-details/customer-credit-note-lines/customer-credit-note-lines-editor.component';
import { CustomerCreditNoteListComponent } from './customer-credit-notes/customer-credit-note-list/customer-credit-note-list.component';
import { CustomerDeliveryNoteDetailComponent } from './customer-delivery-notes/customer-delivery-note-detail/customer-delivery-note-detail.component';
import { CustomerDeliveryNoteLinesEditorComponent } from './customer-delivery-notes/customer-delivery-note-detail/customer-delivery-note-lines/customer-delivery-note-lines-editor.component';
import { CustomerInvoiceCreationDialogComponent } from './customer-delivery-notes/customer-delivery-note-detail/customer-invoice-creation-dialog/customer-invoice-creation-dialog.component';
import { CustomerInvoicePreviewGridComponent } from './customer-delivery-notes/customer-delivery-note-detail/customer-invoice-creation-dialog/customer-invoice-preview-grid/customer-invoice-preview-grid.component';
import { DeliveryNoteToInvoiceGridComponent } from './customer-delivery-notes/customer-delivery-note-detail/customer-invoice-creation-dialog/delivery-note-to-invoice-grid/delivery-note-to-invoice-grid.component';
import { CustomerDeliveryNoteListComponent } from './customer-delivery-notes/customer-delivery-note-list/customer-delivery-note-list.component';
import { CustomerInvoiceDetailComponent } from './customer-invoices/customer-invoice-detail/customer-invoice-detail.component';
import { CustomerInvoiceLinesEditorComponent } from './customer-invoices/customer-invoice-detail/customer-invoice-lines/customer-invoice-lines-editor.component';
import { CustomerInvoicePaymentsComponent } from './customer-invoices/customer-invoice-detail/customer-invoice-payments/customer-invoice-payments.component';
import { CustomerInvoiceListComponent } from './customer-invoices/customer-invoice-list/customer-invoice-list.component';
import { CustomerCreditNoteCreationDialogComponent } from './customer-return-notes/customer-return-note-detail/customer-credit-note-creation-dialog/customer-credit-note-creation-dialog.component';
import { CustomerCreditNotePreviewGridComponent } from './customer-return-notes/customer-return-note-detail/customer-credit-note-creation-dialog/customer-credit-note-preview-grid/customer-credit-note-preview-grid.component';
import { ReturnNoteToCreditNoteGridComponent } from './customer-return-notes/customer-return-note-detail/customer-credit-note-creation-dialog/return-note-to-credit-note-grid/return-note-to-credit-note-grid.component';
import { CustomerReturnNoteDetailComponent } from './customer-return-notes/customer-return-note-detail/customer-return-note-detail.component';
import { CustomerReturnNoteLinesEditorComponent } from './customer-return-notes/customer-return-note-detail/customer-return-note-lines/customer-return-note-lines-editor.component';
import { CustomerReturnNoteListComponent } from './customer-return-notes/customer-return-note-list/customer-return-note-list.component';
import { CustomerPreparationDetailComponent } from './customer-preparations/customer-preparation-detail/customer-preparation-detail.component';
import { CustomerPreparationLinesEditorComponent } from './customer-preparations/customer-preparation-detail/customer-preparation-lines/customer-preparation-lines-editor.component';
import { CustomerPreparationListComponent } from './customer-preparations/customer-preparation-list/customer-preparation-list.component';
import { CustomerSalesPurchaseDetailsComponent } from './customer-sales-purchases/customer-sales-purchase-detail/customer-sales-purchase-details.component';
import { CustomerSalesPurchaseLinesEditorComponent } from './customer-sales-purchases/customer-sales-purchase-detail/customer-sales-purchase-lines/customer-sales-purchase-lines-editor.component';
import { DeliveryNoteCreationDialogComponent } from './customer-sales-purchases/customer-sales-purchase-detail/delivery-note-creation-dialog/delivery-note-creation-dialog.component';
import { DeliveryNoteCreationGridComponent } from './customer-sales-purchases/customer-sales-purchase-detail/delivery-note-creation-dialog/delivery-note-creation-grid/delivery-note-creation-grid.component';
import { DeliveryNotePackagingGridComponent } from './customer-sales-purchases/customer-sales-purchase-detail/delivery-note-creation-dialog/delivery-note-packaging-grid/delivery-note-packaging-grid.component';
import { CustomerPreparationCreationDialogComponent } from './customer-sales-purchases/customer-sales-purchase-detail/preparation-creation-dialog/customer-preparation-creation-dialog.component';
import { EligibleCustomerOrdersGridComponent } from './customer-sales-purchases/customer-sales-purchase-detail/preparation-creation-dialog/eligible-customer-orders-grid/eligible-customer-orders-grid.component';
import { CustomerSalesPurchaseListComponent } from './customer-sales-purchases/customer-sales-purchase-list/customer-sales-purchase-list.component';
import { SalesPurchaseImportComponent } from './customer-sales-purchases/customer-sales-purchase-list/import/customer-sales-purchase-import.component';
import { DialogBoxCloneComponent } from './dialog-box-clone/dialog-box-clone.component';
import { DocumentListComponent } from './document-list/document-list.component';
import { DocumentsRoutingModule } from './documents-routing.module';
import { QuoteDetailComponent } from './quotes/quote-detail/quote-detail.component';
import { LineAnnexListComponent } from './quotes/quote-detail/quote-lines/annexes/annex-list.component';
import QuoteLinesEditorComponent from './quotes/quote-detail/quote-lines/quote-lines-editor.component';
import { QuoteListComponent } from './quotes/quote-list/quote-list.component';
import { StockDocInventoryDetailComponent } from './stock-docs/stock-doc-inventories/stock-doc-inventory-detail/stock-doc-inventory-detail.component';
import { StockDocInventoryListComponent } from './stock-docs/stock-doc-inventories/stock-doc-inventory-list/stock-doc-inventory-list.component';
import { StockDocMovementDetailComponent } from './stock-docs/stock-doc-movements/stock-doc-movement-detail/stock-doc-movement-detail.component';
import StockDocMovementLinesEditorComponent from './stock-docs/stock-doc-movements/stock-doc-movement-detail/stock-doc-movement-lines/stock-doc-movement-lines-editor.component';
import { StockDocTransferListComponent } from './stock-docs/stock-doc-transfers/stock-doc-transfer-list/stock-doc-transfer-list.component';
import { StockDocTransferDetailComponent } from './stock-docs/stock-doc-transfers/stock-doc-transfer-detail/stock-doc-transfer-detail.component';
import { StockDocMovementListComponent } from './stock-docs/stock-doc-movements/stock-doc-movement-list/stock-doc-movement-list.component';
import { SupplierDeliveryNoteDetailComponent } from './supplier-delivery-notes/supplier-delivery-note-detail/supplier-delivery-note-detail.component';
import { SupplierDeliveryNoteLinesEditorComponent } from './supplier-delivery-notes/supplier-delivery-note-detail/supplier-delivery-note-lines/supplier-delivery-note-lines-editor.component';
import { SupplierDeliveryNoteListComponent } from './supplier-delivery-notes/supplier-delivery-note-list/supplier-delivery-note-list.component';
import { SupplierPurchaseOrderDetailComponent } from './supplier-purchase-orders/supplier-purchase-order-detail/supplier-purchase-order-detail.component';
import { SupplierPurchaseOrderLinesEditorComponent } from './supplier-purchase-orders/supplier-purchase-order-detail/supplier-purchase-order-lines/supplier-purchase-order-lines-editor.component';
import { SupplierPurchaseOrderListComponent } from './supplier-purchase-orders/supplier-purchase-order-list/supplier-purchase-order-list.component';
import { SupplierQuoteDetailComponent } from './supplier-quotes/supplier-quote-detail/supplier-quote-detail.component';
import { SupplierQuoteLinesEditorComponent } from './supplier-quotes/supplier-quote-detail/supplier-quote-lines/supplier-quote-lines-editor.component';
import { SupplierQuoteListComponent } from './supplier-quotes/supplier-quote-list/supplier-quote-list.component';
import { SupplierPreparationDetailComponent } from './supplier-preparations/supplier-preparation-detail/supplier-preparation-detail.component';
import { SupplierPreparationLinesEditorComponent } from './supplier-preparations/supplier-preparation-detail/supplier-preparation-lines/supplier-preparation-lines-editor.component';
import { SupplierPreparationListComponent } from './supplier-preparations/supplier-preparation-list/supplier-preparation-list.component';
import { DocTemplateDetailComponent } from './templates/doc-template-detail/doc-template-detail.component';
import { DocTemplateLinesEditorComponent } from './templates/doc-template-detail/doc-template-lines/doc-template-lines-editor.component';
import { DocTemplateListComponent } from './templates/doc-template-list/doc-template-list.component';

@NgModule({
  imports: [
    SharedModule,
    DocumentsRoutingModule,
    DwAgGridModule,
    CoreModule,
    NgbNavModule,
    DwNavLinkDirective,
    NgbScrollSpyModule,
    NgSelectModule,
    LinesEditorComponent,
    PreventEnterDefaultDirective,
    AnnexesListModule,
    TableModule,
    SidePanelModule,
    DialogBoxComponent,
    InvoiceTagComponent,
    NgbTooltipModule,
    AgGridAngular,
    FileUrlPipe,
    KpiGridComponent,
    KpiComponent,
    InformationsAuditedEntityComponent,
    AddressDetailComponent,
    AmountCardComponent,
    NgxMaskDirective,
    NgxMaskPipe,
    ReportViewerComponent,
    DocSidePanelExplanationsComponent,
    DocumentListComponent,
    CustomerSalesPurchaseListComponent,
    CustomerSalesPurchaseDetailsComponent,
    QuoteListComponent,
    QuoteDetailComponent,
    DocConditionsComponent,
    DocCustomerOthersComponent,
    DocSupplierOthersComponent,
    DocClassificationsComponent,
    DocCustomerAddressesComponent,
    DocCustomerDeliveryAddressComponent,
    DocSupplierAddressesComponent,
    DocSupplierDeliveryAddressComponent,
    DocSidePanelTagsComponent,
    QuoteLinesEditorComponent,
    LineAnnexListComponent,
    DocTemplateListComponent,
    DocTemplateDetailComponent,
    CustomerSalesPurchaseLinesEditorComponent,
    DocTemplateLinesEditorComponent,
    DocTemplateSelectionComponent,
    CustomerInvoiceListComponent,
    CustomerInvoiceDetailComponent,
    CustomerInvoiceLinesEditorComponent,
    DocHierarchyComponent,
    DocHierarchyItemComponent,
    DeliveryNoteCreationDialogComponent,
    CustomerPreparationCreationDialogComponent,
    EligibleCustomerOrdersGridComponent,
    CustomerInvoicePaymentsComponent,
    DeliveryNotePackagingGridComponent,
    DeliveryNoteCreationGridComponent,
    CustomerDeliveryNoteListComponent,
    CustomerDeliveryNoteDetailComponent,
    CustomerDeliveryNoteLinesEditorComponent,
    CustomerPreparationListComponent,
    CustomerPreparationDetailComponent,
    CustomerPreparationLinesEditorComponent,
    CustomerInvoiceCreationDialogComponent,
    DeliveryNoteToInvoiceGridComponent,
    CustomerInvoicePreviewGridComponent,
    SalesPurchaseImportComponent,
    CustomerReturnNoteListComponent,
    CustomerReturnNoteDetailComponent,
    CustomerReturnNoteLinesEditorComponent,
    CustomerCreditNoteListComponent,
    CustomerCreditNoteDetailComponent,
    CustomerCreditNoteLinesEditorComponent,
    CustomerReturnNoteLinesEditorComponent,
    CustomerCreditNoteCreationDialogComponent,
    ReturnNoteToCreditNoteGridComponent,
    CustomerCreditNotePreviewGridComponent,
    SupplierQuoteListComponent,
    SupplierQuoteDetailComponent,
    SupplierQuoteLinesEditorComponent,
    SupplierPreparationListComponent,
    SupplierPreparationDetailComponent,
    SupplierPreparationLinesEditorComponent,
    DialogBoxCloneComponent,
    SupplierPurchaseOrderListComponent,
    SupplierPurchaseOrderDetailComponent,
    SupplierPurchaseOrderLinesEditorComponent,
    SupplierDeliveryNoteListComponent,
    SupplierDeliveryNoteDetailComponent,
    SupplierDeliveryNoteLinesEditorComponent,
    StockDocMovementListComponent,
    StockDocMovementDetailComponent,
    StockDocMovementLinesEditorComponent,
    StockDocInventoryListComponent,
    StockDocInventoryDetailComponent,
    StockDocTransferListComponent,
    StockDocTransferDetailComponent,
  ],
  exports: [
    DocConditionsComponent,
    DocCustomerAddressesComponent,
    DocCustomerOthersComponent,
    DocSupplierOthersComponent,
    DocCustomerDeliveryAddressComponent,
    DocSupplierAddressesComponent,
    DocSupplierDeliveryAddressComponent,
    LineAnnexListComponent,
    DocSidePanelTagsComponent,
  ],
  providers: [LowerCasePipe],
})
export class DocumentsModule {}
